import { theme } from "@ovou-inc/ovou-ui";

export const brandBlack = theme.palette.brand.primary.black;
export const brandWhite = theme.palette.brand.primary.white;
export const grey1 = theme.palette.ui.greys.grey1;
export const grey3 = theme.palette.ui.greys.grey3;
export const grey4 = theme.palette.ui.greys.grey4;
export const profileCardLargeScreenWidth = 1020;
export const profileCardSmallScreenWidth = 500;
